<template>
  <div class="default-layout">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DefaultLayout',
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .default-layout {
    margin-top: 40px;
  }

  @include editable-max-width(576px) {
    .default-layout {
      margin-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/Layout.vue